import { Routes, Route } from "react-router-dom";
import BranchOfficeDashboard from "../../Pages/BranchOffice/BranchOfficeDashboard";
import BranchOfficeLayout from "./BranchOfficeLayout";
import BranchOfficeCounsellor from "../../Pages/BranchOffice/BranchOfficeCounsellor";
import AddBranchOfficeFront from "../../Pages/BranchOffice/SubPages/AddBranchOfficeFront";
import BranchOfficeFront from "../../Pages/BranchOffice/BranchOfficeFront";
import AddBranchApplication from "../../Pages/BranchOffice/SubPages/AddBranchApplication";
import BranchOfficeApplication from "../../Pages/BranchOffice/BranchOfficeApplication";
import BranchOfficeLead from "../../Pages/BranchOffice/BranchOfficeLead";
import AddBranchLead from "../../Pages/BranchOffice/SubPages/AddBranchLead";
import AddBranchCounsellor from "../../Pages/BranchOffice/SubPages/AddBranchCounsellor";
import ErrorPage from "../../ErrorPage";


const BranchOfficeRoutes = () => {
  return (
    <BranchOfficeLayout>
      <Routes>
         <Route path="dashboard" element={<BranchOfficeDashboard/>} />
          <Route path="counsellor" element={<BranchOfficeCounsellor/>} />
          <Route path="counsellor/add" element={<AddBranchCounsellor/>} />
          <Route path="front-office/add" element={<AddBranchOfficeFront/>} />
          <Route path="front-office/view" element={<BranchOfficeFront/>} />
          <Route path="application-processor/add" element={<AddBranchApplication/>} />
          <Route path="application-processor/view" element={<BranchOfficeApplication/>} />
<Route path="lead-management/view" element={<BranchOfficeLead/>} />
<Route path="lead-management/add" element={<AddBranchLead/>} />
<Route path="*" element={<ErrorPage />} />
        {/* Add more super admin pages here */}
      </Routes>
    </BranchOfficeLayout>
  );
};

export default BranchOfficeRoutes;
